import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import axiosInstance from "../../../api/api";
import TextWhitTooltip from "../Util/TextWhitTooltip";


const InversionTable = ({ optionName, ciemId }) => {
    const [detalles, setDetalles] = useState([]);
    const [inversion, setInversion] = useState({
        id: null,
        descripcion: "",
        valorTotalMonedaNacional: 0,
        ciemId: ciemId.ciemId,
        type: optionName,
        detalles: [],
    });
    const [showModal, setShowModal] = useState(false);
    const [editingDetalle, setEditingDetalle] = useState(null);
    const [formData, setFormData] = useState({});
    const [tableHeaders, setTableHeaders] = useState([]);

    useEffect(() => {
        fetchDetalles();
    }, []);

    const fetchDetalles = async () => {
        try {
            const res = await axiosInstance.get(
                `inversionTable/${ciemId.ciemId}/${optionName}`
            );
            if (res.data.data != null) {
                const inversionData = res.data.data;
                setInversion(inversionData);
                setDetalles(inversionData.detalles || []);
            }

            const tableHeader = await axiosInstance.get(
                `/detailoption/option/value/${optionName}`
            );
            setTableHeaders(tableHeader.data.data || []);
        } catch (error) {
            console.error("Error al obtener detalles:", error);
        }
    };

    const handleShowModal = (detalle = null) => {
        setEditingDetalle(detalle);
        setFormData(detalle ? { ...detalle } : {});
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingDetalle(null);
        setFormData({});
    };

    const handleChange = (e, field) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    // Guardar (crear o editar) detalle
    const handleSave = async () => {
        let updatedDetalles;

        if (editingDetalle) {
            // Editar detalle existente
            updatedDetalles = detalles.map((d) =>
                d.id === editingDetalle.id ? { ...formData } : d
            );
        } else {
            // Nuevo detalle
            updatedDetalles = [...detalles, formData];
        }
        const updatedInversion = {
            ...inversion,
            detalles: updatedDetalles
        };
        try {
            console.log("updatedDetalles")
            console.log(updatedDetalles)
            // Guarda toda la inversión con los detalles incluidos
            await axiosInstance.post(`/inversionTable/`, updatedInversion);

            setInversion(updatedInversion);
            setDetalles(updatedDetalles);
            fetchDetalles();
            handleCloseModal();
        } catch (error) {
            console.error("Error guardando detalle:", error);
        }
    };

    const handleDelete = async (id) => {
        const confirmar = window.confirm("¿Estás seguro de que deseas eliminar este registro?");
        if (!confirmar) return; // Si el usuario cancela, no hace nada

        try {
            const respuesta = await axiosInstance.delete(`/inversionTable/${id}`);
            alert(respuesta.data.message);
            fetchDetalles();
        } catch (error) {
            console.error("Error eliminando inversión:", error);
            alert("Ocurrió un error al intentar eliminar el registro.");
        }

    };

    return (
        <div style={{ overflowX: "auto" }}>
            <Button
                variant="success"
                className="mb-3"
                onClick={() => handleShowModal()}
            >
                ➕ Nuevo
            </Button>
            <Table striped bordered hover responsive>
                <thead>
                <tr>
                    {tableHeaders
                        .sort((a, b) => a.orden - b.orden)
                        .map((opt) => (
                            <th key={opt.id} title={opt.tooltip || ""}>
                                <TextWhitTooltip value={opt.description} detail={opt} />
                            </th>
                        ))}
                    <th>Acciones</th>
                </tr>
                </thead>
                <tbody>
                {!detalles || detalles.length === 0 ? (
                    <tr>
                        <td colSpan={tableHeaders.length + 1} className="text-center">
                            No hay datos a mostrar
                        </td>
                    </tr>
                ) : (
                    detalles.map((detalle) => (
                        <tr key={detalle.id}>
                            {tableHeaders
                                .sort((a, b) => a.orden - b.orden)
                                .map((header) => (
                                    <td key={header.value}>{detalle[header.value]}</td>
                                ))}
                            <td>
                                <Button
                                    variant="warning"
                                    size="sm"
                                    className="me-2"
                                    onClick={() => handleShowModal(detalle)}
                                >
                                    ✏️ Editar
                                </Button>
                                <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => handleDelete(detalle.id)}
                                >
                                    🗑 Eliminar
                                </Button>
                            </td>
                        </tr>
                    ))
                )}
                {detalles.length > 0 && (
                    <tr className="fw-bold bg-light">
                        <td colSpan={tableHeaders.length - 1} className="text-end">
                            Total:
                        </td>
                        <td colSpan={2}>
                            {inversion.valorTotalMonedaNacional.toLocaleString()}
                        </td>
                    </tr>
                )}
                </tbody>
            </Table>
            {/* Modal */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingDetalle ? "Editar" : "Nuevo"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {tableHeaders.map((opt) =>
                            opt.editable ? (
                                <Form.Group key={opt.id} className="mb-3">
                                    <Form.Label>{opt.description}</Form.Label>
                                    <Form.Control
                                        type={opt.type || "text"}
                                        value={formData[opt.value] || ""}
                                        onChange={(e) => handleChange(e, opt.value)}
                                    />
                                </Form.Group>
                            ) : null
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default InversionTable;